var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherXSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_feather-x-square",
    "data-name": "Icon feather-x-square",
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1078",
    d: "M6.5 4.5h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-14a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2z",
    className: "prefix__cls-2",
    "data-name": "Path 1078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1079",
    d: "M13.5 13.5l6 6",
    className: "prefix__cls-2",
    "data-name": "Path 1079",
    transform: "translate(-3 -3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_1080",
    d: "M19.5 13.5l-6 6",
    className: "prefix__cls-2",
    "data-name": "Path 1080",
    transform: "translate(-3 -3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherXSquare);
export default __webpack_public_path__ + "static/media/icon-feather-x-square.ff6ac13d839325cea4c5b08a1a704d29.svg";
export { ForwardRef as ReactComponent };